import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import styles from "./MyRewardsWidget.module.scss";
import { PRIMARY_GREEN } from "../../utility/constants/common-constants";
import CustomSkeleton from "../../components/custom-skeleton/CustomSkeleton";

const MyRewardsWidgetSkeleton: React.FC = () => {
  return (
    <Box className={styles.myRewardsWidget}>
      {/* Header Skeleton */}
      <Box mb={3}>
        <CustomSkeleton variant="text" width={180} height={40} />
      </Box>

      <Box className={styles.widgetContainer}>
        {/* Left side - Circle + placeholder */}
        <Box className={styles.leftCircleWrapper}>
          <Box className={styles.backgroundCircle} />
          <CustomSkeleton variant="circular" width={50} height={50} />
        </Box>

        {/* Right side */}
        <Box className={styles.rightContent}>
          <Box className={styles.tierNameBox}>
            <CustomSkeleton variant="text" width={80} height={24} />
            <CustomSkeleton
              variant="text"
              width={200}
              height={40}
              sx={{ mb: 2 }}
            />
          </Box>

          <Box mb={8}>
            <Box className={styles.pointsRow}>
              <CustomSkeleton variant="text" width={50} height={24} />
              <CustomSkeleton variant="text" width={40} height={18} />
              <Box sx={{ flexGrow: 1 }} />
              <CustomSkeleton variant="text" width={120} height={18} />
            </Box>

            {/* Progress Bar Skeleton */}
            <CustomSkeleton
              variant="rectangular"
              height={22}
              sx={{ borderRadius: "10px" }}
            />
            {/* Label placeholders */}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <CustomSkeleton width={30} height={18} />
              <CustomSkeleton width={30} height={18} />
              <CustomSkeleton width={30} height={18} />
              <CustomSkeleton width={30} height={18} />
            </Box>
          </Box>
        </Box>

        {/* Footer */}
        <Box className={styles.footerBar} sx={{ cursor: "default" }}>
          <Typography variant="body1" color="common.white">
            <CustomSkeleton variant="text" width={120} height={20} />
          </Typography>
          <Chip
            label={<CustomSkeleton width={24} />}
            className={styles.rewardsChip}
            sx={{
              backgroundColor: "#FFE9D9",
              color: PRIMARY_GREEN,
              fontWeight: "bold",
              fontSize: "16px",
              mx: 0.5,
            }}
          />
          <Typography variant="body1" color="common.white" mr={1}>
            <CustomSkeleton variant="text" width={80} height={20} />
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MyRewardsWidgetSkeleton;
